var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcResBannerCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 89,
    height: 88,
    viewBox: "0 0 89 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 1707481357"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 48095890"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle 36",
    filter: "url(#filter0_d_561_58141)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 47.3125,
    y: 2.9292,
    width: 36,
    height: 36,
    rx: 8,
    transform: "rotate(20 47.3125 2.9292)",
    fill: "url(#paint0_linear_561_58141)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle",
    filter: "url(#filter1_bd_561_58141)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13 44C13 42.8954 13.8954 42 15 42H69C70.1046 42 71 42.8954 71 44V65C71 69.4183 67.4183 73 63 73H21C16.5817 73 13 69.4183 13 65V44Z",
    fill: "url(#paint1_linear_561_58141)",
    fillOpacity: 0.5,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3693 44C13.3693 43.0994 14.0994 42.3693 15 42.3693H69C69.9006 42.3693 70.6307 43.0994 70.6307 44V65C70.6307 69.2143 67.2143 72.6307 63 72.6307H21C16.7857 72.6307 13.3693 69.2143 13.3693 65V44Z",
    stroke: "url(#paint2_linear_561_58141)",
    strokeWidth: 0.738695,
    shapeRendering: "crispEdges"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_2",
    filter: "url(#filter2_bd_561_58141)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13 32C13 28.6863 15.6863 26 19 26H65C68.3137 26 71 28.6863 71 32V38C71 39.1046 70.1046 40 69 40H15C13.8954 40 13 39.1046 13 38V32Z",
    fill: "url(#paint3_linear_561_58141)",
    fillOpacity: 0.5,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3693 32C13.3693 28.8903 15.8903 26.3693 19 26.3693H65C68.1097 26.3693 70.6307 28.8903 70.6307 32V38C70.6307 38.9006 69.9006 39.6307 69 39.6307H15C14.0994 39.6307 13.3693 38.9006 13.3693 38V32Z",
    stroke: "url(#paint4_linear_561_58141)",
    strokeWidth: 0.738695,
    shapeRendering: "crispEdges"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_3",
    d: "M52 24.3701C52 22.7133 53.3431 21.3701 55 21.3701C56.6569 21.3701 58 22.7133 58 24.3701V28.3701C58 30.027 56.6569 31.3701 55 31.3701C53.3431 31.3701 52 30.027 52 28.3701V24.3701Z",
    fill: "url(#paint5_linear_561_58141)",
    stroke: "url(#paint6_linear_561_58141)",
    strokeWidth: 0.74
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_4",
    d: "M26 24.3701C26 22.7133 27.3431 21.3701 29 21.3701C30.6569 21.3701 32 22.7133 32 24.3701V28.3701C32 30.027 30.6569 31.3701 29 31.3701C27.3431 31.3701 26 30.027 26 28.3701V24.3701Z",
    fill: "url(#paint7_linear_561_58141)",
    stroke: "url(#paint8_linear_561_58141)",
    strokeWidth: 0.74
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 1015 (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.1692 49.811C54.2769 50.8923 54.2769 52.6455 53.1692 53.7268L41.656 65.9187C40.1791 67.3604 37.7846 67.3604 36.3077 65.9187L30.8308 60.572C29.7231 59.4907 29.7231 57.7375 30.8308 56.6562C31.9384 55.5749 33.7343 55.5749 34.842 56.6562L38.9818 60.6976L49.158 49.811C50.2657 48.7297 52.0616 48.7297 53.1692 49.811Z",
    fill: "url(#paint9_linear_561_58141)",
    stroke: "url(#paint10_linear_561_58141)",
    strokeWidth: 0.35,
    strokeLinecap: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_561_58141",
    x: 27.251,
    y: 5.18066,
    width: 61.6387,
    height: 61.6387,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0693333 0 0 0 0 0.216667 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_561_58141"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_561_58141",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_bd_561_58141",
    x: 1.91957,
    y: 34.613,
    width: 80.1609,
    height: 53.1609,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 3.16584
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_561_58141"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.69348
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.54021
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_backgroundBlur_561_58141",
    result: "effect2_dropShadow_561_58141"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_561_58141",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_bd_561_58141",
    x: 1.91957,
    y: 18.613,
    width: 80.1609,
    height: 36.1609,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 3.16584
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_561_58141"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.69348
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.54021
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_backgroundBlur_561_58141",
    result: "effect2_dropShadow_561_58141"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_561_58141",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_561_58141",
    x1: 38.6485,
    y1: -5.54792,
    x2: 101.913,
    y2: 6.23542,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7D7AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2A27CE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_561_58141",
    x1: 7.63914,
    y1: 58.6196,
    x2: 89.2013,
    y2: 71.6464,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.28
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_561_58141",
    x1: -17.2608,
    y1: 31.5274,
    x2: 6.43646,
    y2: 83.7033,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1EBFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_561_58141",
    x1: 7.63914,
    y1: 33.5056,
    x2: 81.9833,
    y2: 59.7981,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.28
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_561_58141",
    x1: -17.2608,
    y1: 21.2705,
    x2: -11.6661,
    y2: 48.5468,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1EBFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_561_58141",
    x1: 52,
    y1: 21.5,
    x2: 63.8629,
    y2: 29.6478,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.37035,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_561_58141",
    x1: 55,
    y1: 21.3701,
    x2: 55,
    y2: 31.3701,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_561_58141",
    x1: 26,
    y1: 21.5,
    x2: 37.8629,
    y2: 29.6478,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.37035,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_561_58141",
    x1: 29,
    y1: 21.3701,
    x2: 29,
    y2: 31.3701,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_561_58141",
    x1: 24.8,
    y1: 52.1534,
    x2: 53.3196,
    y2: 73.1935,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.358244,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_561_58141",
    x1: 42,
    y1: 49,
    x2: 42,
    y2: 67,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcResBannerCalendar);
export default __webpack_public_path__ + "static/media/ic_res_banner_calendar.3a5dc117285990ca84319d5c5f9aec95.svg";
export { ForwardRef as ReactComponent };